'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionsTrigger', ['$scope', '$stateParams', 'TGTriggers', '$state', function ($scope, $stateParams, TGTriggers, $state) {
        $scope.trigger = $stateParams.trigger;
        $scope.triggerID = $stateParams.id;
        $scope.triggerObjectID = $stateParams.triggerObjectID;
        $scope.saving = false;
        $scope.loading = false;

        if ($stateParams.id != null) {
            $scope.loading = true;

            TGTriggers.getByID($stateParams.id, $stateParams.triggerObjectID).then(function (trigger) {
                $scope.trigger = trigger;
                $scope.loading = false;
            });            
        }
        else {
            $state.go('internal.inspecting.denied');
        }

        $scope.save = function () {
            $scope.saving = true;
            $scope.trigger.trigger_action_values = [];

            $scope.trigger.trigger_actions.forEach(function (action) {
                if (action.multiple) {
                    action.trigger_action_values.forEach(function (tav) {
                        tav.trigger_action_id = action.id;
                        tav.trigger_object_id = $scope.triggerObjectID;
                        $scope.trigger.trigger_action_values.push(tav);
                    })
                }
                else {
                    if (action.text) {
                        if (action.trigger_action_value != null && action.trigger_action_value.value_text != null && action.trigger_action_value.value_text != '') {
                            action.trigger_action_value.trigger_action_id = action.id;
                            action.trigger_action_value.trigger_object_id = $scope.triggerObjectID;
                            $scope.trigger.trigger_action_values.push(action.trigger_action_value);
                        }
                    }
                    else {
                        if (action.trigger_action_value != null && action.trigger_action_value.value_id != null && action.trigger_action_value.value_id != '') {
                            action.trigger_action_value.trigger_action_id = action.id;
                            action.trigger_action_value.trigger_object_id = $scope.triggerObjectID;
                            $scope.trigger.trigger_action_values.push(action.trigger_action_value);
                        }
                    }
                }
            })

            TGTriggers.save($scope.trigger, $scope.triggerObjectID).then(function (trigger) {
                $state.go('internal.inspecting.resource.triggers');
                $scope.saving = false;
            })
        }

        $scope.setText = function (options, value) {
            if (options != null && value != null) {
                options.forEach(function (opt) {
                    if (opt.id == value.value_id) {
                        value.value_text = opt.name;
                    }
                })
            }
        }
    }])
;